import React from "react";
import { Container, Row } from "reactstrap";

import Annonce from "./Annonce";
import AgentBanner from "./AgentBanner";
import SearchAgent from "./SearchAgent";

// console.log("token: ", localStorage.getItem("authUser"));

const Agent = () => {
  return (
    <Container fluid className="">
      <AgentBanner />
      <Row>
        <SearchAgent />
        <Annonce />
      </Row>
    </Container>
  );
};

export default Agent;
